import {useEffect, useState} from "react";

const useRunOnce = (callback) => {
    const [isRun, setIsRun] = useState(false);
    useEffect(() => {
        if (!isRun) {
            callback()
            setIsRun(true)
        }
    }, [isRun, callback])
}

export default useRunOnce